import { React, useState, useEffect, useContext, useRef, useCallback } from 'react'
import { Button } from 'bootstrap'
import "../css/PagesCommonStyle.css"
import { faMagnifyingGlass, faPrint, faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel, faFilePdf, faTrashCan, faFile } from '@fortawesome/free-regular-svg-icons'
import { useSelector, useDispatch } from 'react-redux';
import { faTriangleExclamation, faStar, faCircleInfo, faArrowsRotate, faAnglesDown, faAnglesUp, faXmark, faArrowRight, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { AgingReportConstants, APIConstants, CommonAPIConstants, FilesAPIConstants, InsurancePaymentReportConstants } from '../utilities/Constants'
import * as XLSX from 'xlsx';
import { setUser } from '../redux/actions/userActions'
import { Link } from 'react-router-dom'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import { FixedSizeList as List } from 'react-window'
import Draggable from 'react-draggable'



const AgingReport = () => {

    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Default value for the input is the current date
    const defaultDate = getCurrentDate();
    const defaultFromDate = new Date('2015-01-01');

    const today = new Date();
    const formatCurDate = format(today, 'MM/dd/yyyy');

    const rowsPerPage = 100;

    const [isHideChecked, setIsHideChecked] = useState(false);
    const [updatedTabledata, setUpdatedTableData] = useState([]);
    const [error, setError] = useState(null);
    const [startDate, setStartDate] = useState(''); // State to store start date
    const [endDate, setEndDate] = useState('');     // State to store end date
    const [loading, setLoading] = useState(false);

    const [selecteSubType, setSelecteSubType] = useState('0');
    const [selectInsType, setSelectInsType] = useState('0');

    const ServiceLocValues = [
        { TextField: 'Office - 11', ValueField: '11' },
        { TextField: 'Home - 12', ValueField: '12' },
        { TextField: 'SUD - 57', ValueField: '57' },
        { TextField: 'Lab - 81', ValueField: '81' },


    ];

    const [ServiceLocations, setServiceLocations] = useState([]);
    const [selectedCMS33a, setSelectedCMS33a] = useState('0');
    const [selectedCMS33b, setSelectedCMS33b] = useState('0');
    const [selectedBillingNPI, setSelectedBillingNPI] = useState('0');
    const [selectedPracticeProvider, setSelectedPracticeProvider] = useState('0');
    const [selectedProvidersCategory, setSelectedProvidersCategory] = useState('0');
    const [selectedSearchFilter, setSelectedSearchFilter] = useState('3');
    const [selectedLocation, setSelectedLocation] = useState('-1');
    const [selectedStatusRadioButton, setSelectedStatusRadioButton] = useState('');
    const [selectedCheckedRadioButton, setSelectedCheckedRadioButton] = useState('0');
    const [selectedServiceLocation, setSelectedServicelocation] = useState('0');
    const [selectedFilterProvider, setSelectedFilterProvider] = useState('0');


    const [locations, setLocations] = useState([]);
    const [cms33aData, setCMS33aData] = useState([]);
    const [cms33bData, setCMS33bData] = useState([]);
    const [providerCategory, setProviderCategory] = useState([]);
    const [searchFilterData, setSearchFilterData] = useState([]);
    const [practiceProvider, setPracticeProvider] = useState([]);
    const [statusRadioButton, setStatusRadioButton] = useState([]);
    const [checkedRadioButton, setCheckedRadioButton] = useState([]);

    const [BillingNPIs, setBillingNPIs] = useState([]);

    const [searchText, setSearchText] = useState('');

    const [suggestions, setSuggestions] = useState([]);

    const [sPatID, setSPatID] = useState('');
    const [sInsID, setSInsID] = useState('');
    const [sClaimStatus, setsClaimStatus] = useState('');


    const [tableDetails, setTableDetails] = useState([]);

    const [selectAllDropdown, setSelectAllDropdown] = useState([]);


    const [selectedRows, setSelectedRows] = useState([]);

    const [insuranceAllCheckbox, setInsuranceAllCheckbox] = useState([]);
    const [SecInsuranceAllCheckbox, setSecInsuranceAllCheckbox] = useState([]);
    const [filteredTableDetails, setFilteredTableDetails] = useState(tableDetails);


    const [displayedRecords, setDisplayedRecords] = useState([]);
    const [selectedDropdownValue, setSelectedDropdownValue] = useState('AppointmentDate');

    const [showSelectErrorModal, setShowSelectErrorModal] = useState(false);
    const [showConfirmSaveModal, setShowConfirmSaveModal] = useState(false);
    const [showVerifiedSaveModal, setShowVerifiedSaveModal] = useState(false);
    const [showServiceErrorModal, setShowServiceErrorModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteSuccessModal, setDeleteSuccessModal] = useState(false);
    const [closeClaimsModal, setCloseClaimsModal] = useState(false);
    const [savedRowCount, setSavedRowCount] = useState(0);
    const [deleteRowCount, setDeleteRowCount] = useState(0);
    const [successTimer, setSuccessTimer] = useState(5000);

    const [appointmentDates, setAppointmentDates] = useState([]);
    const [selectLocationID, setSelectLocationID] = useState('-1');
    const [showFilters, setShowFilters] = useState(false);
    const [showDetails, setShowDetails] = useState(false);

    const [claimservices, setClaimServices] = useState([]);
    const [selectedCptValue, setSelectedCptValue] = useState('');
    const [cptValueList, setCptValueList] = useState([]);
    const [selectedCPTCode, setSelectedCPTCode] = useState('');
    const [insOrPatFilter, setInsOrPatFilter] = useState('updatedby');
    const [practiceBillingNPIs, setPracticeBillingNPIs] = useState([]);
    const [selectpracticeBillingNPIs, setSelectPracticeBillingNPIs] = useState('');
    const [selectedViewType, setSelectedViewType] = useState('0');
    const [selectedClaimService, setSelectedClaimService] = useState('0');
    const [isClaimClosed, setIsClaimClosed] = useState('false');

    const [claimFilterRecCountsTableData, setClaimFilterRecCountsTableData] = useState([]);
    const [claimRecCountsTableData, setClaimRecCountsTableData] = useState(claimFilterRecCountsTableData);
    const [defaultUpdatedBy, setDefaultUpdatedBy] = useState('Test Biller');

    const [checkedServices, setCheckedServices] = useState([]);
    const [isNoServiceChecked, setIsNoServiceChecked] = useState(false);

    const [selectedPolicyRows, setSelectedPolicyRows] = useState([]);
    const [selectedInsRows, setSelectedInsRows] = useState([]);
    const [selectedSecInsuranceRows, setSelectedSecInsuranceRows] = useState([]);
    const [selectedAdminWriteRows, setSelectedAdminWriteRows] = useState([]);
    const [selectedWriteOffRows, setSelectedWriteOffRows] = useState([]);
    const [selectedResubmitRows, setSelectedResubmitRows] = useState([]);
    const [transactionCodes, setTransactionCodes] = useState([]);
    const [selectedTransactionCode, setSelectedTransactionCode] = useState('');
    const [verifiedData, setVerifiedData] = useState([]);
    const [selectedVerifiedData, setSelectedVerifiedData] = useState([]);
    const [billingNpiValue, setBillingNpiValue] = useState('');
    const [claimId, setClaimId] = useState('');
    const [cptCode, setCptCode] = useState('');
    const [dos, setDos] = useState('');
    const [savingData, setSavingData] = useState(false);
    const [dataSaved, setDataSaved] = useState(false);
    const [filterType, setFilterType] = useState('all');
    const [claimDOS, setClaimDOS] = useState('');
    const [isTotal, setIsTotal] = useState(false);

    const [isClaimChecked, setIsClaimChecked] = useState(true);
    const [isSubmitChecked, setIsSubmitChecked] = useState(true);
    const [isNonSubmitChecked, setIsNonSubmitChecked] = useState(true);
    const [isSentChecked, setIsSentChecked] = useState(true);
    const [isPaidChecked, setIsPaidChecked] = useState(true);
    const [isRecvdChecked, setIsRecvdChecked] = useState(true);
    const [isDeniedChecked, setIsDeniedChecked] = useState(true);
    const [isRejectedChecked, setIsRejectedChecked] = useState(true);
    const [isForwardChecked, setIsForwardChecked] = useState(true);
    const [isPostedChecked, setIsPostedChecked] = useState(true);

    const [rcvdwriteOffValue, setRcvdWriteOffValue] = useState('0');

    const [claimRecvdChargeValue, setClaimRcvdChargeValue] = useState([]);
    const [claimWriteOffValue, setClaimWriteOffvalue] = useState([]);

    const [claimSecRecvdChargeValue, setSecClaimRcvdChargeValue] = useState([]);

    const [deductibleAmt, setDeductible] = useState([]);
    const [patientRes, setPatientRes] = useState([]);
    const [adjustmentAmt, setAdjustmentAmt] = useState([]);
    const [secPendingAmt, setsecPendingAmt] = useState([]);

    const [isDataUpdated, setIsDataUpdated] = useState(false);
    const [cptChequeNumber, setcptChequeNumber] = useState([]);
    const [cptChequeDate, setCptChequeDate] = useState([]);
    const [isFocused, setIsFocused] = useState(false);
    const [checkDate, setCheckDate] = useState('');
    const [formatCheckDate, setFormatCheckDate] = useState('');
    const [claimPayerRefID, setClaimPayerRefID] = useState([]);
    const [claimNotes, setClaimNotes] = useState([]);

    const [cptSecChequeNumber, setcptsecChequeNumber] = useState([]);
    const [cptSecChequeDate, setCptSecChequeDate] = useState([]);
    const [secClaimPayerRefID, setSecClaimPayerRefID] = useState([]);

    const [checkEligibilityColor, setCheckEligibilityColor] = useState('');
    const [isLoading, setIsLoading] = useState('');
    const [isInStatus, setIsInStatus] = useState(false);

    const [payRefColor, setPayRefColor] = useState(false);
    const [activeRow, setActiveRow] = useState(null);
    const [selectedServiceIDs, setSelectedServiceIDs] = useState([]);
    const [prevFilter, setPrevFilter] = useState('');
    const [queryFilter, setQueryFilter] = useState('');
    const [statusFilter, setStatusFilter] = useState(null);
    const [selectedAllChecked, setSelectedAllChecked] = useState(false);
    const [selectAllWriteOffChecked, setSelectAllWriteOffChecked] = useState(false);
    const [selectAllAdminWriteChecked, setSelectAllAdminWriteChecked] = useState(false);
    const [selectAllResubmit, setSelectAllResubmit] = useState(false);
    const [selectedData, setSelectedData] = useState('');
    const [isPageLoad, setisPageLoad] = useState('1');
    const [searchByClaimDos, setSearchByClaimDos] = useState('');

    const [showDataModal, setShowDataModal] = useState(false);
    const [eventData, setEventData] = useState([]);
    const [selectedClaimID, setselectedClaimID] = useState([]);
    const [showFaxModal, setShowFaxModal] = useState(false);

    const [reGenerateData, setReGenerateData] = useState(false);
    const [rowState, setRowState] = useState({});
    const [isHidden, setIsHidden] = useState(false);
    const [selectedPatname, setselectedPatname] = useState('');
    const [selectedDOB, setselectedDOB] = useState('');
    const [isStartOpen, setIsStartOpen] = useState(false);
    const [isEndOpen, setIsEndOpen] = useState(false);
    const [searchByLocation, setSearchByLocation] = useState('');
    const [claimID, setClaimID] = useState('');
    const [activeCounts, setActiveCounts] = useState(null);
    const [visibleRecords, setVisibleRecords] = useState(rowsPerPage);
    const [searchByInsuName, setSearchByInsuName] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });

    const tableContainerRef = useRef(null);


    const sAuthToken = useSelector((state) => state.user.token);

    const loadMoreRecords = useCallback(() => {
        setVisibleRecords((prev) => Math.min(prev + rowsPerPage, filteredTableDetails.length));
    }, [filteredTableDetails.length]);


    const handleScroll = useCallback(() => {
        const isAtBottom =
            window.innerHeight + window.scrollY >= document.documentElement.scrollHeight;

        if (isAtBottom) {
            loadMoreRecords();
        }
    }, [loadMoreRecords]);




    useEffect(() => {
        setVisibleRecords(rowsPerPage);
    }, [filteredTableDetails]);




    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [handleScroll]);





    const dispatch = useDispatch();




    const userData = useSelector((state) => state.user.user);


    localStorage.setItem('userData2', JSON.stringify(userData));


    var userPracticeID = userData ? userData.practiceID : null;

    var userId = userData ? userData.userID : null;








    useEffect(() => {
        document.title = 'AR Aging Report'


        const initialCheckedServices = claimservices.map((item) => item.ServiceID);
        setCheckedServices(initialCheckedServices);
        setShowServiceErrorModal(false)
    }, [claimservices]);






    useEffect(() => {
        let timerId;


        if (showSuccessModal || deleteSuccessModal) {
            // Start the timer when the success modal is shown
            timerId = setTimeout(() => {
                setShowSuccessModal(false);
                setDeleteSuccessModal(false);
                setShowServiceErrorModal(false);

            }, successTimer);
        }


        return () => {
            clearTimeout(timerId);
        };
    }, [showSuccessModal, successTimer, deleteSuccessModal]);


    const modalRef = useRef(null);





    useEffect(() => {

        const handleOutsideClick = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setShowConfirmSaveModal(false);
            }
        };

        // Add event listener
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);





    const handleStartDateChange = (date) => {
        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setStartDate(formattedDate);
            setIsStartOpen(false)

        } else {
            setStartDate(null);
        }
    };


    const handleEndDateChange = (date) => {

        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setEndDate(formattedDate);

            setIsEndOpen(false)

        } else {
            setEndDate(null);
        }
    };



    const getMonths = (selectedYear) => {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth();

        return Array.from({ length: 12 }, (v, k) => {
            if (selectedYear === currentYear && k > currentMonth) {
                return null;
            }
            return (
                <option key={k} value={k}>
                    {format(new Date(selectedYear, k), 'MMMM')}
                </option>
            );
        }).filter(option => option !== null);
    };








    const handleTodayClick = (dateType) => {
        const today = new Date();

        if (dateType === "start" && startDate) {
            setStartDate(today);

            setIsStartOpen(false);
        }

        if (dateType === "end" && endDate) {
            setEndDate(today);
            setIsEndOpen(false);
        }
    };



    const CalendarContainer = ({ children }) => (
        <div style={{ zIndex: '99px', backgroundColor: 'white', border: '1px solid lightgray' }}>
            {children}
            <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
                <button type="button" className='today-btn' onClick={() => handleTodayClick("end")}>
                    Today
                </button>

            </div>
        </div>
    );


    const CalendarStartContainer = ({ children }) => (
        <div style={{ zIndex: '99px', backgroundColor: 'white', border: '1px solid lightgray' }}>
            {children}
            <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
                <button type="button" className='today-btn' onClick={() => handleTodayClick("start")}>
                    Today
                </button>

            </div>
        </div>
    );








    useEffect(() => {

        getProvider();
    }, []);



    const getProvider = () => {


        var jsonOBJ = {
            PracticeID: userPracticeID,
            SearchByRole: 0
        }

        var sInputJSON = JSON.stringify(jsonOBJ);


        const url =
            APIConstants.COMMON_BASE_URL +
            `CommonData/GetPracticeProviders?sJSONInput=${sInputJSON}`;
        console.log("URL", url);

        const response = fetch(url, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${sAuthToken}`,
            },
        })
            .then((response) => response.json())
            .then((data) => {


                console.log("Providers>>>>>>", data);
                setPracticeProvider(Array.isArray(data) ? data : []);

            })

            .catch((error) => {
                console.error("Error fetching data: ", error);
            });
    };



    useEffect(() => {
        if (
            isPageLoad &&
            startDate &&
            endDate &&
            !hasLoadedInitially.current
        ) {
            handleGetAgingReport();
            hasLoadedInitially.current = true;
        }
    }, [isPageLoad, startDate, endDate]);



    const formatDate = (date) => {
        return date.toLocaleDateString("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
        });
    };



    useEffect(() => {
        const today = new Date();
        const thirtyOneDaysAgo = new Date(today);
        thirtyOneDaysAgo.setDate(today.getDate() - 365);

        const formattedStart = formatDate(thirtyOneDaysAgo);
        const formattedEnd = formatDate(today);

        setStartDate(formattedStart);
        setEndDate(formattedEnd);

        setisPageLoad(1);
    }, []);




    //Bind the table details



    const handleGetAgingReport = async () => {
        setLoading(true);

        var objInput = {
            sPracticeID: userPracticeID,
            sFromDate: startDate,
            sToDate: endDate,
            sProviderID: selectedPracticeProvider,
            sDateType: selectedDropdownValue,
            sClaimSubType: selecteSubType,
            sClaimSubType: 1

        }

        var sInputJSON = JSON.stringify(objInput);


        const url = `${APIConstants.BASE_URL_BILLING}${AgingReportConstants.GetAgingReport}?sInputJSON=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {



                const parsedData = JSON.parse(data)

                setTimeout(() => {
                    setLoading(false);
                    setTableDetails(parsedData);
                    setFilteredTableDetails(parsedData);
                }, 100);
                console.log("Response of" + AgingReportConstants.GetAgingReport, filteredTableDetails);


            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }



    const hasLoadedInitially = useRef(false);


    const handleOpenModal = () => {


        setShowConfirmSaveModal(true);

    };







    const handleCloseModals = () => {
        // Close all modals

        setShowConfirmSaveModal(false);

        setShowVerifiedSaveModal(false);
        setShowSelectErrorModal(false);
        setCloseClaimsModal(false);
        setShowServiceErrorModal(false);
        setShowFaxModal(false);
        setShowDataModal(false)

    };

    const handleOpenDeleteModal = () => {
        if (selectedRows.length === 0) {


            setShowSelectErrorModal(true);
        } else {


            setShowDeleteModal(true);
        }
    };





    const handleDelete = () => {

        const updatedRows = tableDetails.filter((row, index) => !selectedRows.includes(index));

        setTableDetails(updatedRows);


        setShowDeleteModal(false)
        setDeleteSuccessModal(true)
        setSelectedRows([]);
        setDeleteRowCount(selectedRows.length);
    };








    function getAppLoactionLabelClass(appLocationName) {
        if (appLocationName === 'TP1' || appLocationName === 'TL3') {
            return 'applocation';
        } else if (appLocationName === 'Sec') {
            return 'applocation2';
        } else if (appLocationName === 'NE') {
            return 'applocation3';
        }
        else if (appLocationName === 'SUB') {
            return 'applocation4';
        }
        else if (appLocationName === 'Location Vijaya' || appLocationName === 'Tnl') {
            return 'applocation5';
        }
        else {
            return '';
        }


    }



    function getRecievedChargeClass(recievedCharge) {
        if (recievedCharge === 0) {
            return 'nonpaid-claims';
            // } else if (recievedCharge === "") {
            //   return 'paid-claims';
        } else {
            return '';
        }


    }








    const toggleFilters = () => {
        setShowFilters(!showFilters);
    };

    const closeFilters = () => {
        setShowFilters(false);
    };

    const toggleDetails = () => {
        setShowDetails(!showDetails);
    };

    const formatDOSDate = (dateString) => {


        if (!dateString) {
            return ""; // or any default value you want to display for null dates
        }

        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
            return "Invalid Date"; // handle cases where the date string is not valid
        }

        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        });
    };


    const formatSubmitDate = (dateString) => {
        if (!dateString) {
            return ""; // or any default value you want to display for null dates
        }

        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
            return "Invalid Date"; // handle cases where the date string is not valid
        }

        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        });
    };






    const handleInputClick = () => {
        setIsFocused(true);
    };



    const handleRowClick = (index) => {
        setActiveRow(index);
    };



    const getVerifiedBy = (name) => {
        if (!name) {
            return ''; // Return an empty string if 'name' is undefined
        }

        return name
            .split(" ")
            .map((word) => (word[0] ? word[0].toUpperCase() : ''))
            .join("");
    };








    const handlePrint = () => {
        if (tableRef.current) {


            const tableHTML = tableRef.current.outerHTML;
            const printWindow = window.open("", "_blank");

            printWindow.document.writeln(`
            <html>
              <head>
                <title class="print-title">Insurance Payment Report</title>
                <style>
                  body {
                    font-family: Arial, sans-serif;
                    margin: 10px;
                    font-size: 15px;
                    color: #000;
                  }
      
                  .print-title {
                    text-align: center;
                    font-size: 24px;
                    font-weight: bold;
                    margin-bottom: 20px;
                    color: #1a9b8c;
                  }
      
                  .table-container {
                    width: 100%;
                    overflow-x: auto;
                  }
      
                  table {
                    width: 100%;
                    border-collapse: collapse;
                    table-layout: auto; 
                    word-wrap: break-word;
                  }
      
                  th, td {
                    border: 1px solid black;
                    padding: 5px;
                    text-align: left;
                    font-size: 14px;
                  }
      
                  th {
                    background-color: #f4f4f4;;
                    font-size: 14px;
                    color: white !important;
                    border: 1px solid black;
                    text-align: top;
                    transform-origin: left bottom;
                    height: 120px;
                    
                  }
                  td{
                      font-size:14px
                    }
      
                  @media print {
                    @page {
                      size: A4 landscape;
                      margin: 10mm;
                    }
      
                    .table-container {
                      overflow: visible !important;
                    }
      
                     .hide-on-print {
                      display: none !important;
                    }
      
                    
                    .input{
                      width: 20px !important;
                      color: black;
                      
                    }

                     .input-date{
                      width: 70px !important;
                      color: black;
                      
                    }

                   
                    .show-on-print {
                        width: 30px;
                    }

                    .print-label {

                       display: inline-block;
                        max-width: 40px; 
                        word-wrap: break-word;
                        white-space: normal !important;
                        overflow-wrap: break-word;
                        font-size: 12px;
                     }
                  }
      
                  body {
                      -webkit-print-color-adjust: exact;
                    }
                  }
                </style>
              </head>
              <body>
               
                <div class="table-container">${tableHTML}</div>
                <script>
                  window.onload = function() {
                    window.print();
                  };
                  window.onafterprint = function() {
                    window.close();
                  };
                </script>
              </body>
            </html>
          `);

            printWindow.document.close();
        } else {
            console.error("Table reference is not set.");
        }
    };




    const tableRef = useRef('');


    const exportToExcel = () => {
        const pagename = 'InsurancePaymentReport';
        const table = tableRef.current;
        let sPrintableData = table ? table.innerHTML : '';

        const vRegEx = new RegExp("gvClosedClaims", "");
        sPrintableData = sPrintableData.replace(vRegEx, "gvAcceptdClaims");


        const PrintableDataDetails = {
            PrintableData: sPrintableData,
            PageName: pagename,
        };

        const InputJSONLevelOne = JSON.stringify(PrintableDataDetails);
        const InputJSON = JSON.stringify(InputJSONLevelOne);


        fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExcelFile, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: InputJSON,
        })
            .then(response => response.json()) // Parse the response as JSON
            .then(data => {

                if (data && data[2]) {

                    const url = data[2];
                    window.open(url, '_blank');

                }
            })
            .catch(error => {
                console.error('Export to Excel failed', error);
            });
    };





    const exportToPDF = () => {
        const pagename = 'InsurancePaymentReport';
        const table = tableRef.current.parentNode;
        let sPrintableData = table ? table.innerHTML : '';

        const vRegEx = new RegExp("gvClosedClaims", "");
        sPrintableData = sPrintableData.replace(vRegEx, "gvAcceptdClaims");


        const PrintableDataDetails = {
            PrintableData: sPrintableData,
            PageName: pagename,
        };

        const InputJSONLevelOne = JSON.stringify(PrintableDataDetails);
        const InputJSON = JSON.stringify(InputJSONLevelOne);


        fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExportPdfFile, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: InputJSON,
        })
            .then(response => response.json()) // Parse the response as JSON
            .then(data => {


                if (data && data[2]) {

                    const url = data[2];
                    window.open(url, '_blank');


                }
            })
            .catch(error => {
                console.error('Export to PDF failed', error);
            });
    };



    const handleLinkClick = (item, sDateRange) => {
        const url = `/#/ARAgingReportClaimDetails/?sProviderID=${selectedPracticeProvider}&sInsuranceID=${item.InsID}&sDateRange=${sDateRange}&sClaimSubType=${selecteSubType}&sDateType=${selectedDropdownValue}&sFromDate=${startDate}&sToDate=${endDate}`;
        window.open(url, '_blank');
    };








    useEffect(() => {
        const filteredData = tableDetails.filter(item =>
            item.Insurance && typeof item.Insurance === 'string'
                ? item.Insurance.toLowerCase().includes(searchByInsuName.toLowerCase())
                : true
        );

        setFilteredTableDetails(filteredData);
    }, [searchByInsuName, tableDetails]);



    const getValue = (val, index) => {
        const parts = val?.split('-') || [];
        const raw = parts[selecteSubType === '0' ? 0 : 1];
        return Number(raw) || 0;
    };



    const totals = {
        ZeroToThirty: 0,
        ThirtyOneToSIxty: 0,
        SixtyOneToNinty: 0,
        NintyOneToOneTwenty: 0,
        OneTwentyPlus: 0,

    };

    tableDetails.forEach(item => {
        totals.ZeroToThirty += getValue(item.ZeroToThirty);
        totals.ThirtyOneToSIxty += getValue(item.ThirtyOneToSIxty);
        totals.SixtyOneToNinty += getValue(item.SixtyOneToNinty);
        totals.NintyOneToOneTwenty += getValue(item.NintyOneToOneTwenty);
        totals.OneTwentyPlus += getValue(item.OneTwentyPlus);

    });


    const formatTotal = (value) => {
        const num = parseFloat(value) || 0;
        return selecteSubType === '0' ? `$${num.toFixed(2)}` : num;
    };



    const columnTotals = {
        ZeroToThirty: 0,
        ThirtyOneToSIxty: 0,
        SixtyOneToNinty: 0,
        NintyOneToOneTwenty: 0,
        OneTwentyPlus: 0,
    };

    let grandTotal = 0;

    filteredTableDetails.forEach((item) => {
        const rowTotal =
            (parseFloat(item.ZeroToThirty) || 0) +
            (parseFloat(item.ThirtyOneToSIxty) || 0) +
            (parseFloat(item.SixtyOneToNinty) || 0) +
            (parseFloat(item.NintyOneToOneTwenty) || 0) +
            (parseFloat(item.OneTwentyPlus) || 0);

        columnTotals.ZeroToThirty += parseFloat(item.ZeroToThirty) || 0;
        columnTotals.ThirtyOneToSIxty += parseFloat(item.ThirtyOneToSIxty) || 0;
        columnTotals.SixtyOneToNinty += parseFloat(item.SixtyOneToNinty) || 0;
        columnTotals.NintyOneToOneTwenty += parseFloat(item.NintyOneToOneTwenty) || 0;
        columnTotals.OneTwentyPlus += parseFloat(item.OneTwentyPlus) || 0;

        grandTotal += rowTotal;


        item.rowTotal = rowTotal;
    });


    return (
        <>



            <div className='main-container'>
                <div className='container-style'>

                    <header className='hv-pagehead'>
                        <div>
                            <h1 className='hv-pagehead__title'>AR Aging Report</h1>
                            <div className='hv-pagehead__sub'>Outstanding balances by payer and aging bucket</div>
                        </div>
                    </header>

                

                            <div className='date-container' style={{ width: '100%', height: '60px' }}>

                                <div className='mt-2'>
                                    <label onClick={getProvider}>Provider:</label>

                                    <select
                                        name="select"
                                        style={{ width: '200px', height: '30px', border: '1px solid black', borderRadius: '5px' }}
                                        value={selectedPracticeProvider}
                                        onChange={(e) =>
                                            setSelectedPracticeProvider(e.target.value)}
                                    >
                                        <option value="0">{userData.practiceName}</option>

                                        {practiceProvider?.map((item, index) => (
                                            <option value={item.ProviderID} key={index}>
                                                {item.ProviderName}
                                            </option>
                                        ))}
                                    </select>



                                    <select name="select" style={{ height: '25px', height: '30px', marginLeft: '30px', border: '1px solid black', borderRadius: '5px' }}
                                        value={selectedDropdownValue}
                                        onChange={(e) => setSelectedDropdownValue(e.target.value)}
                                    >

                                        <option value="AppointmentDate" >DOS</option>

                                        <option value="SubmitDate" >Submit Date</option>
                                    </select>

                                </div>



                                <div className="datepicker-container mt-2" style={{ marginLeft: '30px', zIndex: 10 }}>
                                    <label>From:</label>
                                    <DatePicker
                                        selected={startDate ? new Date(startDate) : null}
                                        onChange={handleStartDateChange}
                                        dateFormat="MM/dd/yyyy"
                                        maxDate={new Date()}
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        yearDropdownItemNumber={100}
                                        readOnly={isHideChecked}
                                        className={`clnImgTextBoxes ${startDate ? 'default-selected' : ''}`}
                                        placeholderText="MM/dd/yyyy"

                                        calendarContainer={CalendarStartContainer}
                                        open={isStartOpen}
                                        onFocus={() => setIsStartOpen(true)}
                                        onInputClick={() => setIsStartOpen(true)}
                                        onClickOutside={() => setIsStartOpen(false)}
                                        renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                                            const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                                            const selectedMonth = selectedDate.getMonth();
                                            const selectedYear = selectedDate.getFullYear();

                                            return (
                                                <div>
                                                    <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ height: '50px' }}>
                                                        {"<"}
                                                    </button>
                                                    <select
                                                        value={selectedMonth}
                                                        onChange={({ target: { value } }) => changeMonth(Number(value))}
                                                    >
                                                        {getMonths(selectedYear)}
                                                    </select>
                                                    <select
                                                        value={selectedYear}
                                                        onChange={({ target: { value } }) => changeYear(Number(value))}
                                                    >
                                                        {Array.from({ length: 100 }, (v, k) => (
                                                            <option key={k} value={new Date().getFullYear() - k}>
                                                                {new Date().getFullYear() - k}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ height: '50px' }}>
                                                        {">"}
                                                    </button>
                                                </div>
                                            );
                                        }}
                                    />
                                </div>

                                <div className="datepicker-container mt-2" style={{ marginLeft: '5px', zIndex: 10 }}>
                                    <label>To:</label>
                                    <DatePicker
                                        selected={endDate ? new Date(endDate) : null}
                                        onChange={handleEndDateChange}
                                        dateFormat="MM/dd/yyyy"
                                        maxDate={new Date()}
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        yearDropdownItemNumber={100}
                                        className={`clnImgTextBoxes ${endDate ? 'default-selected' : ''}`}
                                        placeholderText="MM/dd/yyyy"
                                        popperPlacement="bottom-start"
                                        readOnly={isHideChecked}

                                        calendarContainer={CalendarContainer}
                                        open={isEndOpen}
                                        onFocus={() => setIsEndOpen(true)}
                                        onInputClick={() => setIsEndOpen(true)}
                                        onClickOutside={() => setIsEndOpen(false)}
                                        renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                                            const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                                            const selectedMonth = selectedDate.getMonth();
                                            const selectedYear = selectedDate.getFullYear();

                                            return (
                                                <div>
                                                    <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ height: '25px' }}>
                                                        {"<"}
                                                    </button>
                                                    <select
                                                        value={selectedMonth}
                                                        onChange={({ target: { value } }) => changeMonth(Number(value))}
                                                    >
                                                        {getMonths(selectedYear)}
                                                    </select>
                                                    <select
                                                        value={selectedYear}
                                                        onChange={({ target: { value } }) => changeYear(Number(value))}
                                                    >
                                                        {Array.from({ length: 100 }, (v, k) => (
                                                            <option key={k} value={new Date().getFullYear() - k}>
                                                                {new Date().getFullYear() - k}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ height: '25px' }}>
                                                        {">"}
                                                    </button>
                                                </div>
                                            );
                                        }}
                                    />
                                </div>


                                <FontAwesomeIcon style={{ marginLeft: '20px', marginTop: '10px', cursor: 'pointer', fontSize: '1.5rem' }}
                                    onClick={handleGetAgingReport}

                                    icon={faMagnifyingGlass} />



                                <FontAwesomeIcon style={{ marginLeft: '100px', marginTop: '10px', cursor: 'pointer', fontSize: '1.5rem' }} onClick={handlePrint} icon={faPrint} />
                                <FontAwesomeIcon style={{ marginLeft: '8px', color: 'green', marginTop: '10px', cursor: 'pointer', fontSize: '1.5rem' }} onClick={exportToExcel} icon={faFileExcel} />
                                <FontAwesomeIcon style={{ marginLeft: '8px', color: 'red', marginTop: '10px', cursor: 'pointer', fontSize: '1.5rem' }} onClick={exportToPDF} icon={faFilePdf} />


                            </div>

                    {loading && (
                        <div className="overlay">
                            <div className="spinner-container">
                                <div className="spinner-grow text-danger" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <div className="spinner-grow text-warning" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <div className="spinner-grow text-info" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    )}


                    <div className='subtable-container'>
                        <table className="table table-hover table-striped table-bordered border border-white responsive mt-1" style={{ marginLeft: '4px', width: '100%' }} ref={tableRef}>

                            <thead>

                                <tr className='align-top' >

                                    <th className='col-sm col-th  text-white' style={{ backgroundColor: '#1a9b8c' }}>#</th>

                                    <th className='col col-th-style  text-white' style={{ backgroundColor: '#1a9b8c', width: '400px', fontSize: '1.3rem' }}>Insurance
                                        <br />
                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                            value={searchByInsuName}
                                            onChange={(e) => setSearchByInsuName(e.target.value)}
                                        />
                                    </th>


                                    <th className='col col-th-style text-white ' style={{ backgroundColor: '#1a9b8c', fontSize: '1.3rem' }}>0-30

                                    </th>

                                    <th className='col col-th-style  text-white' style={{ backgroundColor: '#1a9b8c', fontSize: '1.3rem' }}>31-60
                                    </th>

                                    <th className='col col-th-style  text-white' style={{ backgroundColor: '#1a9b8c', fontSize: '1.3rem' }}>61-90

                                    </th>




                                    <th className='col col-th-style text-white ' style={{ backgroundColor: '#1a9b8c', fontSize: '1.3rem' }}>91-120


                                    </th>
                                    <th className='col col-th-style text-white' style={{ backgroundColor: '#1a9b8c', fontSize: '1.3rem' }}>120+

                                    </th>

                                    <th className='col col-th-style text-white' style={{ backgroundColor: '#1a9b8c', fontSize: '1.3rem' }}>Total

                                    </th>

                                </tr>


                            </thead>

                            <tbody>
                                {filteredTableDetails.map((item, index) => (
                                    <tr className={`${activeRow === index ? "table-warning" : ""}`}
                                        key={index}
                                        onClick={() => handleRowClick(index)}>
                                        <td>{index + 1}</td>
                                        <td>{item.Insurance}</td>

                                        <td>
                                            <Link style={{ color: 'black' }} onClick={() => handleLinkClick(item, 0)}>${item.ZeroToThirty}</Link>
                                        </td>
                                        <td>
                                            <Link style={{ color: 'black' }} onClick={() => handleLinkClick(item, 31)}>${item.ThirtyOneToSIxty}</Link>
                                        </td>
                                        <td>
                                            <Link style={{ color: 'black' }} onClick={() => handleLinkClick(item, 61)}> ${item.SixtyOneToNinty}</Link>
                                        </td>
                                        <td>
                                            <Link style={{ color: 'black' }} onClick={() => handleLinkClick(item, 91)}>${item.NintyOneToOneTwenty}</Link>
                                        </td>
                                        <td>
                                            <Link style={{ color: 'black' }} onClick={() => handleLinkClick(item, 121)}>${item.OneTwentyPlus}</Link>
                                        </td>
                                        <td><strong>{formatTotal(item.rowTotal)}</strong></td>

                                    </tr>
                                ))}


                                <tr className='table-secondary'>
                                    <td colSpan={2}><strong>Total</strong></td>
                                    <td><strong>{formatTotal(totals.ZeroToThirty)}</strong></td>
                                    <td><strong>{formatTotal(totals.ThirtyOneToSIxty)}</strong></td>
                                    <td><strong>{formatTotal(totals.SixtyOneToNinty)}</strong></td>
                                    <td><strong>{formatTotal(totals.NintyOneToOneTwenty)}</strong></td>
                                    <td><strong>{formatTotal(totals.OneTwentyPlus)}</strong></td>
                                    <td><strong>{formatTotal(grandTotal)}</strong></td>
                                </tr>



                            </tbody>

                        </table>



                    </div>






                    {showServiceErrorModal && (

                        <div className='alert-modal'>
                            <label></label>
                            <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.1rem', backgroundColor: 'red' }} onClick={handleCloseModals} icon={faXmark} />
                            <p>please select atleast one Filter from Service...</p>

                        </div>

                    )}


                    {showSelectErrorModal && (

                        <div className='alert-modal'>
                            <label></label>
                            <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.1rem', backgroundColor: 'red' }} onClick={handleCloseModals} icon={faXmark} />
                            <p>please select atleast one claim...</p>

                        </div>

                    )}




                    {showSuccessModal && (
                        <div className='alert-modal'>
                            <label></label>
                            <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.1rem', backgroundColor: 'red' }} onClick={handleCloseModals} icon={faXmark} />
                            <p>Selected Claim Successfully Closed</p>

                        </div>
                    )}




                </div>


            </div>




        </>
    )
}

export default AgingReport;